<h6>
    <b>{{order.isCreditor() ? this.order.creditor.name : this.order.debtor.name}}</b>
    <span *ngIf="order.isCreditor()" style="vertical-align: 2px;" class="badge  badge-primary  float-right">Kreditor</span>
    <span *ngIf="order.isCreditor() === false" style="vertical-align: 2px;" class="badge  badge-primary  float-right">Debitor</span>
</h6>

<table *ngIf="invoiceContact" class="table  table-bordered  table-sm  mb-0">
    <tr *ngIf="invoiceContact.getContactFieldObjectBySlug('name')">
        <td>Navn:</td>
        <td><b>{{invoiceContact.getContactFieldBySlug('name') || '-'}}</b></td>
    </tr>
    <tr *ngIf="invoiceContact.getContactFieldObjectBySlug('address_1')">
        <td>Adresse:</td>
        <td>
            <b>{{invoiceContact.getContactFieldBySlug('address_1') || '-'}}</b><br>
            <ng-container *ngIf="invoiceContact.getContactFieldObjectBySlug('address_2')"><b>{{invoiceContact.getContactFieldBySlug('address_2')}}</b><br></ng-container>
            <ng-container *ngIf="invoiceContact.getContactFieldObjectBySlug('address_3')"><b>{{invoiceContact.getContactFieldBySlug('address_3')}}</b><br></ng-container>
        </td>
    </tr>
    <tr *ngIf="invoiceContact.getContactFieldObjectBySlug('zip')">
        <td>Post nr.:</td>
        <td><b>{{invoiceContact.getContactFieldBySlug('zip') || '-'}}</b></td>
    </tr>
    <tr *ngIf="invoiceContact.getContactFieldObjectBySlug('city')">
        <td>By:</td>
        <td><b>{{invoiceContact.getContactFieldBySlug('city') || '-'}}</b></td>
    </tr>
    <tr *ngIf="invoiceContact.getContactFieldObjectBySlug('phone')">
        <td>Tlf.:</td>
        <td><b>{{invoiceContact.getContactFieldBySlug('phone') || '-'}}</b></td>
    </tr>
    <tr *ngIf="invoiceContact.getContactFieldObjectBySlug('email')">
        <td>Email:</td>
        <td><b>{{invoiceContact.getContactFieldBySlug('email') || '-'}}</b></td>
    </tr>
</table>
